import { gql } from '@apollo/client';

export const getUsersInspiredByArticle = gql`
  query getUsersInspiredByArticle($articleId: ID!) {
    userArticleRelations(
      where: {
        article: { id: { equals: $articleId } }
        relationType: { equals: inspire }
        user: { deactivated: { equals: false } }
      }
      orderBy: { timestamp: desc }
    ) {
      id
      user {
        id
        name
        username
        publicAddress
        profileImage {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
      }
      timestamp
    }
  }
`;
